module.exports = __webpack_public_path__ + "img/admission-4.18850d58.jpg";